import React from 'react';
import { Link } from 'react-router-dom';
import useSEO from '../hooks/useSEO';

export default function Error403() {
  useSEO('Adgang nægtet (403) | Chokolenten ApS', 'Adgang nægtet.');

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="max-w-md w-full text-center bg-cream-light p-8 sm:p-12 rounded-2xl border border-choc-dark/10 shadow-lg flex flex-col items-center gap-6 animate-in zoom-in-95 duration-200">
        
        {/* Ikon */}
        <div className="w-20 h-20 rounded-full bg-berry-accent/10 flex items-center justify-center text-berry-accent relative">
          <i className="fa-solid fa-lock text-3xl" />
        </div>

        {/* Overskrift */}
        <div className="flex flex-col gap-2">
          <span className="text-xs font-sans uppercase tracking-[0.2em] text-berry-accent font-bold">Fejl 403</span>
          <h1 className="text-3xl font-serif font-bold text-choc-dark">
            Adgang nægtet
          </h1>
        </div>

        {/* Beskrivelse */}
        <p className="text-sm text-choc-dark/70 font-sans leading-relaxed">
          Du har desværre ikke adgang til denne side. Måske er det vores hemmelige chokoladeopskrifter, du forsøger at få fingrene i? 😉
        </p>

        {/* Knapper */}
        <div className="flex flex-col gap-2 w-full mt-2">
          <Link
            to="/"
            className="w-full bg-berry-accent hover:bg-berry-accent/90 text-white font-sans font-semibold py-3 px-4 rounded-xl transition-colors shadow-sm cursor-pointer"
          >
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="w-full bg-transparent hover:bg-choc-dark/5 text-choc-dark border border-choc-dark/20 font-sans font-semibold py-3 px-4 rounded-xl transition-colors cursor-pointer"
          >
            Kontakt os
          </Link>
        </div>

      </div>
    </div>
  );
}
